/**
 * フレームワークの定数
 */
export namespace BaseConst {

    /**
     * タイトル格納用
     */
    export const SCOPE_TITLE: string = 'title';

    /**
     * 履歴管理用のパラメータ名
     */
    export const PARAM_TIMESTAMP: string = 'fwts';
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/BaseConst.ts
 **/